<ion-item lines="none" class="form-group-column">
  <ion-label class="form-label">
    {{ labelKey() | translate }}
    @if (isRequired()) {
      <span class="required-indicator" aria-label="required">*</span>
    }
  </ion-label>
  <div class="form-field-wrapper">
    <button type="button" class="date-control" [class.input-error]="errorMessage()"
      (click)="presentPicker($event)" (blur)="handleBlur()">
      <span class="date-text" [class.is-placeholder]="!internalValue()">
        @if (internalValue()) {
          {{ internalValue() | localeDate }}
        } @else {
          {{ datePlaceholder() }}
        }
      </span>
      <span class="calendar-icon" aria-hidden="true"></span>
    </button>
    <ion-popover class="calendar-popover" [isOpen]="isOpen()" [event]="popoverEvent()" [showBackdrop]="false"
      [arrow]="false" side="bottom" alignment="start" (didDismiss)="handleDismiss()">
      <ng-template>
        <ion-datetime presentation="date" [value]="internalValue() || null" [locale]="datetimeLocale()"
          [min]="min()" [max]="max()" (ionChange)="handleDateChange($event)"></ion-datetime>
      </ng-template>
    </ion-popover>
    <mbp-form-error [message]="errorMessage()"></mbp-form-error>
  </div>
</ion-item>

